import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import MapReducer from './reducers/MapReducer';
import MarkersReducer from './reducers/MarkersReducer';
import AllStudiesReducer from './reducers/AllStudiesReducer';
import SidebarReducer from './reducers/SidebarReducer';
import PopupReducer from './reducers/PopupReducer';
import FilteredReducer from './reducers/FilteredReducer';
import StudyDetailReducer from './reducers/StudyDetailReducer';
import SpeciesReducer from './reducers/SpeciesReducer';
import CountryReducer from './reducers/CountryReducer';
import ReferenceReducer from './reducers/ReferenceReducer';
import AuthReducer from './reducers/AuthReducer';

const Store = createStore(
    combineReducers({
      map: MapReducer,
      markers: MarkersReducer,
      allStudies: AllStudiesReducer,
      sb: SidebarReducer,
      popup: PopupReducer,
      filtered: FilteredReducer,
      studyDetail: StudyDetailReducer,
      species: SpeciesReducer,
      country: CountryReducer,
      reference: ReferenceReducer,
      auth: AuthReducer
    }),
    applyMiddleware(thunk)
  );
export default Store
